const entity = {
  id: null,
  warehouseId: null,
  warehouse: {},
  reason: "",
  type: null,
  subType: null,
  state: null,
  details: [],
  products: [],
  referrals: [],
  active: true,
  created: null,
  updated: null,
};

export default entity;